import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
import { HazardStripe } from './HazardStripe';
export function FinalCTA() {
  return <section className="bg-ink text-center" data-id="element-61" data-mp="3ueqfl8yh8xe2">
      <HazardStripe data-id="element-62" data-mp="c7tw1mrnowv3" />
      <div className="blueprint-grid px-3 py-4 sm:px-6" data-id="element-63" data-mp="c8c035kk8fdk">
        <div className="mx-auto max-w-xl" data-id="element-64" data-mp="84ns4ls0nhrs">
          <h2 className="font-display text-[1.55rem] font-extrabold uppercase leading-none text-white sm:text-[2.1rem]" data-id="element-65" data-mp="83m8vu0ujoyz">
            ONE LAST <span className="text-hazard" data-id="element-66" data-mp="h5vfi8szuy73">QUESTION</span>
          </h2>
          <p className="mt-1.5 text-[0.8rem] leading-[1.4] text-white/85 sm:text-[0.92rem]" data-id="element-67" data-mp="h5lnygsawiza">
            When you arrive at a construction site with multiple crews, subcontractors, material
            deliveries, unfinished activities, changing priorities, and paperwork waiting to be
            completed...
          </p>
          <p className="mt-1 font-display text-[1.02rem] font-extrabold uppercase leading-tight text-hazard sm:text-[1.3rem]" data-id="element-68" data-mp="14t3niyht4lct">
            Do you have one organized system to manage everything—or are you still putting it together
            as the day unfolds?
          </p>
          <p className="mt-1 text-[0.8rem] leading-[1.4] text-white/85 sm:text-[0.92rem]" data-id="element-69" data-mp="2h3zss7visgou">
            Stop managing construction operations through scattered notes, disconnected spreadsheets,
            and paperwork created from scratch.
          </p>
          <p className="mt-1 font-display text-[0.74rem] font-bold uppercase text-white sm:text-[0.88rem]" data-id="element-70" data-mp="2v4amdio7s9dp">
            Plan the work. Coordinate the crews. Track the materials. Monitor the progress. Document the
            results.
          </p>

          <BoxImage className="mx-auto mt-2 max-w-[250px] sm:max-w-[310px]" data-id="element-71" data-mp="34vezecubxk5w" />

          <p className="mt-2 font-display text-[1.3rem] font-extrabold uppercase leading-none text-white sm:text-[1.75rem]" data-id="element-72" data-mp="39rvob99cs2k1">
            🏗️ CONSTRUCTION <span className="text-hazard" data-id="element-73" data-mp="3it3bav6f5gyt">SITE PRO™</span>
          </p>
          <p className="mt-1 font-display text-[0.64rem] font-bold uppercase text-steel sm:text-[0.8rem]" data-id="element-74" data-mp="3itd3mpexs07o">
            THE COMPLETE CONSTRUCTION SITE MANAGEMENT SYSTEM
          </p>
          <p className="mt-0.5 font-display text-[0.6rem] font-bold uppercase tracking-[0.06em] text-hazard sm:text-[0.76rem]" data-id="element-75" data-mp="1eqtlbigqkv6p">
            Plan • Coordinate • Track • Monitor • Document • Control
          </p>

          <div className="mx-auto mt-2 max-w-md" data-id="element-76" data-mp="1nongur6ofkst">
            <p className="font-display text-[0.8rem] font-extrabold uppercase text-white sm:text-[0.95rem]" data-id="element-77" data-mp="22ebf1jjka3cb">
              🔥 GET THE COMPLETE SYSTEM TODAY —{' '}
              <span className="whitespace-nowrap rounded bg-hazard px-1.5 text-ink" data-id="element-78" data-mp="1xi48ppn96ptu">$27 USD</span>
            </p>
            <div className="mt-1.5" data-id="element-79" data-mp="27dxtfwb4lpmp">
              <CTAButton label="🏗️ GET CONSTRUCTION SITE PRO™" data-id="element-80" data-mp="27ez80arcou96" />
            </div>
            <p className="mt-2 text-[0.66rem] font-bold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-81" data-mp="h0yp5eyjsqi9">
              Immediate Access • Digital Delivery
            </p>
            <p className="mt-0.5 text-[0.66rem] font-bold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-82" data-mp="2vya7cgxpvpo">
              🛡️ 7-Day Money-Back Guarantee
            </p>
          </div>
        </div>
      </div>
    </section>;
}